var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import linker from '../linker';
import showError from '../central/showError';
import { CategoryNaviItem } from './molecules';
import { TermNaviService } from '../services/TermNaviService';
var CategoryNavi = (function (_super) {
    __extends(CategoryNavi, _super);
    function CategoryNavi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.termNotFound = false;
        _this.isSubNav = false;
        _this.showArrow = false;
        _this.naviItemsLoaded = false;
        _this.naviItems = [];
        return _this;
    }
    CategoryNavi.prototype.mounted = function () {
        this.load();
    };
    CategoryNavi.prototype.load = function () {
        var _this = this;
        if (SP.Guid.isValid(this.termSetId)) {
            var srv = TermNaviService.start(this.termSetId);
            var termPath = srv.getCurrentTermPath();
            this.isSubNav = termPath.length > 0;
            this.showArrow = this.isSubNav || window.$servicePortal.isMobile;
            window.addEventListener('riResponsive', function (evnt) {
                _this.showArrow = _this.isSubNav || !!evnt.detail.isMobile;
            });
            srv.loadTermItemsOfTerm(termPath).then(function (items) {
                if (items === null) {
                    _this.termNotFound = true;
                    if (_this.notFoundUrl) {
                        window.location.href = _this.notFoundUrl;
                    }
                }
                else {
                    _this.naviItems = items;
                    _this.naviItemsLoaded = true;
                }
            });
        }
        else {
            showError('CategoryNaviTermSetId in Portalkonfiguration ist nicht gesetzt!');
        }
    };
    __decorate([
        Prop({ type: String, })
    ], CategoryNavi.prototype, "header", void 0);
    __decorate([
        Prop({ type: String })
    ], CategoryNavi.prototype, "termSetId", void 0);
    __decorate([
        Prop({ type: String })
    ], CategoryNavi.prototype, "notFoundUrl", void 0);
    __decorate([
        Prop({ type: String })
    ], CategoryNavi.prototype, "servicesUrl", void 0);
    CategoryNavi = __decorate([
        Component({
            components: {
                CategoryNaviItem: CategoryNaviItem,
            },
        })
    ], CategoryNavi);
    return CategoryNavi;
}(Vue));
export default CategoryNavi;
linker.register('categoryNavi', CategoryNavi);
